export const config = {
  title: 'Integrity Collection LLC',
  meta: {
    description:
      'Integrity Collection LLC provides professional and confidential drug and alcohol testing services in Buena Vista, CO, ensuring compliance and workplace safety.',
    keywords: [
      'Drug Testing',
      'Alcohol Testing',
      'Pre-Employment Screening',
      'Probation Testing',
      'DOT Compliance Testing',
      'Integrity Collection LLC',
      'Buena Vista CO Drug Testing',
      'Court-Ordered Testing',
      'Workplace Drug Screening'
    ],
    author: 'Integrity Collection LLC',
    canonicalUrl: 'https://integritycollectionsllc.com/',
  },
  sections: {
    header: {
      businessName: 'Integrity Collection LLC',
    },
    sectionB: {
      heroTitle: 'Integrity Collection LLC',
      heroSubtitle: 'Reliable Drug & Alcohol Testing Services in Buena Vista, CO',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '+17192216148',
      phoneLabel: '(719) 221-6148',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1165744638/photo/doctor-in-blue-uniform-and-latex-gloves-is-holding-an-empty-plastic-container-for-taking.jpg?s=612x612&w=0&k=20&c=pXMryWZSQTIK2BsWy929pYWRxpTLdFgacvMgzjRHVt4=',
      cardData: [
        {
          title: 'Confidential & Secure',
          description:
            'We provide private, secure, and accurate drug and alcohol testing services.',
        },
        {
          title: 'Fast & Reliable Results',
          description:
            'Our state-of-the-art testing ensures quick and dependable results.',
        },
        {
          title: 'Compliance & Workplace Safety',
          description:
            'Helping businesses and individuals meet legal and professional requirements.',
        },
      ],
      description:
        'Integrity Collection LLC specializes in drug and alcohol testing services for employment screening, probation, DOT compliance, and more.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our range of professional testing services designed for businesses, individuals, and legal compliance.',
      cards: [
        {
          title: 'Pre-Employment Drug Testing',
          description:
            'Ensure workplace safety and compliance with our professional screening services.',
          imageSrc: 'https://media.istockphoto.com/id/1203934257/photo/sample-collection-from-test-tube.jpg?s=612x612&w=0&k=20&c=OVJSCCSrktQp6q4D3sh51rGujBNlS2zBh6T9xHIgykQ=',
          imageAlt: 'Pre-Employment Drug Testing',
        },
        {
          title: 'DOT Compliance Testing',
          description:
            'Testing services for Department of Transportation (DOT) compliance, ensuring safety on the job.',
          imageSrc: 'https://media.istockphoto.com/id/872025442/photo/research-and-educational-laboratory.jpg?s=612x612&w=0&k=20&c=wtjm-v7_tWCi_22qtHa_p5-o4DSDfS54qw6Y1BdHe68=',
          imageAlt: 'DOT Compliance Testing',
        },
        {
          title: 'Court-Ordered & Probation Testing',
          description:
            'Accurate and confidential testing services to meet court and probationary requirements.',
          imageSrc: 'https://media.istockphoto.com/id/173844222/photo/medical-personnel-hand-holding-a-urine-sample-bottle.jpg?s=612x612&w=0&k=20&c=OYXIzDkjyytBV4_WIfnH7bEpFI1BC-fPLajF4pmXY1c=',
          imageAlt: 'Court-Ordered & Probation Testing',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Post-Accident Drug Testing',
        'Random Drug Screening',
        'Teen & Family Drug Testing',
        'Athletic Drug Testing',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/1217811857/photo/doctor-in-a-white-coat-holds-a-empty-plastic-container-for-urine-specimen.jpg?s=612x612&w=0&k=20&c=GnP3Vx-X0SnaZWTyk-iyieV98zVGPjkUqypQqlIN_PI=',
        alt: 'Integrity Collection LLC Team',
      },
      aboutText: [
        'Integrity Collection LLC is a trusted provider of drug and alcohol testing services in Buena Vista, CO.',
        'We are committed to offering confidential, accurate, and reliable testing solutions for businesses, individuals, and legal requirements.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Integrity Collection LLC Logo',
      businessName: 'Integrity Collection LLC',
      contact: {
        phone: '+17192216148',
        phoneLabel: '(719) 221-6148',
        email: 'intergritycollection.llc@gmail.com',
        website: 'https://integritycollectionsllc.com/',
        address: '109 Brookdale Ave. Suite H, Buena Vista, CO 81211',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/IntegrityCollectionLLC',
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '109 Brookdale Ave. Suite H, Buena Vista, CO 81211',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3088.987654321012!2d-106.1323456!3d38.8423456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8765671234567890%3A0xabcdef1234567890!2s109%20Brookdale%20Ave%2C%20Buena%20Vista%2C%20CO%2081211!5e0!3m2!1sen!2sus!4v1710412345678!5m2!1sen!2sus',
    },
  },
};

export default config;
